module.exports = __webpack_public_path__ + "img/hinrundensieger@2x.87a009ae.png";